import http from '@/utils/request'

export const getCountAchievements =() =>{
  return http.request({
    url:"/work-station-schedule/countAchievements",
    method:"GET"
  })
}

export const getProjectList =() =>{
  return http.request({
    url:"/work-station-schedule/getProjectList",
    method:"GET"
  })
}

export const getWaitTaskList =(params) =>{
  return http.request({
    url:"/work-station-schedule/getWaitTaskList",
    method:"GET",
    params:params
  })
}
export const add =(data) =>{
  return http.request({
    url:"/work-station-schedule",
    method:"POST",
    data:data
  })
}

export const update = (data)=>{
  return http.request({
    url:"/work-station-schedule",
    method:"PUT",
    data:data
  })
}

export const del = (params)=>{
  return http.request({
    url:"/work-station-schedule/" +params,
    method:"DELETE",
  })
}
// export const page =(params) =>{
//   return request({
//     url:"/work-station-schedule/page",
//     method:"GET",
//     params:params
//   })
// }
export const listByDate =(params) =>{
  return http.request({
    url:"/work-station-schedule/listByDate",
    method:"GET",
    params:params
  })
}

export const countTodayTask = () =>{
  return http.request({
    url:"/work-station-schedule/countTodayTask",
    method:"GET"
  })
}

export const auditHistoryPage = (params)=>{
  return http.request({
    url:"/work-station-schedule/auditHistoryPage",
    method:"GET",
    params:params
  })
}
